import { render, staticRenderFns } from "./dashboard-container.vue?vue&type=template&id=1bf18d17&scoped=true&lang=pug"
import script from "./dashboard-container.js?vue&type=script&lang=js&external"
export * from "./dashboard-container.js?vue&type=script&lang=js&external"
import style0 from "./dashboard-container.vue?vue&type=style&index=0&id=1bf18d17&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf18d17",
  null
  
)

export default component.exports